import Modal from 'components/Layout/Modal';
import RegistrationFollowUpsTemplatesForm from 'components/V2ForNewAbstractFlow/ResourceSide/NewPaperDetails/RegistrationFollowUpsTemplatesForm';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  encrypt,
  getDataFromLocalStorage,
  getEmailSubject,
  getRegistrationTemplatesPreview,
} from 'utils/helpers';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { templateInitialValues } from 'utils/helpers/ResourceSideNewAbstractFlow/initialValues';
import CheckBox from 'components/form/CheckBox';
import Button from 'components/form/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  handleSendFollowUpsData,
  throwError,
  throwSuccess,
} from 'store/slices';
import { membershipType } from 'utils/constants';

const PreviewPopup = ({ onHide, followupsName, userAbstractIds }) => {
  const params = useParams();
  const { eID } = params;
  const templatePreview = useRef(null);
  const paperData = { event_id: eID };
  const [btnLoading, setBtnLoading] = useState('');
  const [formInitialValues, setFormInitialValues] = useState({
    followUps: followupsName || '',
    preferences: {
      whatsapp: false,
      email: false,
    },
  });

  const userType = getDataFromLocalStorage('user_type');
  const findType = membershipType.find((o) => o.id === userType);

  const navigate = useNavigate();

  const formRef = useRef();

  useEffect(() => {
    if (followupsName) {
      const templateValues = templateInitialValues[followupsName] || {};
      const updatedValues = {
        followUps: followupsName,
        preferences: {
          whatsapp: false,
          email: false,
        },
        ...templateValues,
      };
      setFormInitialValues(updatedValues);
    }
  }, [followupsName]);

  const validationSchema = Yup.object({
    followUps: Yup.string().required('Follow-up type is required'),
    preferences: Yup.object().test(
      'at-least-one',
      'At least one option must be selected',
      (value) => value?.whatsapp || value?.email
    ),
  });

  const dispatch = useDispatch();
  const handleSend = async (value) => {
    setBtnLoading(true);

    if (templatePreview?.current) {
      const htmlContent = templatePreview.current.innerHTML.trim();

      const mailSubject = getEmailSubject(value);
      const { followUps, preferences, ...rest } = value;
      const payload = {
        abstact_ids: userAbstractIds,
        followups_stage: value?.followUps,
        mail_subject: mailSubject,
        followups_data: JSON.stringify(rest),
        mail_template: encrypt(htmlContent),
        event_id: eID,
        alert_type: 1,
      };
      const formData = new FormData();
      for (let key in payload) {
        formData.append(key, payload[key]);
      }
      for (let key in value?.preferences) {
        formData.append(`send_via[]`, value?.preferences[key]);
      }
      const response = await dispatch(handleSendFollowUpsData(formData));
      if (response?.status === 200) {
        if (formRef.current) {
          formRef.current.resetForm();
        }
        dispatch(throwSuccess(response?.message));
        onHide();
        navigate(
          `/${findType?.type}/follow-up-discount/${eID}/manual-follow-up`
        );
      } else {
        dispatch(throwError({ message: response?.messsage }));
      }

      setBtnLoading(false);
    }
  };

  return (
    <Modal
      size="lg"
      width={'1320px'}
      onHide={onHide}
      titleBesideClose="Preview"
      titleBesideCloseClassName="cps-15"
      isTitleBorder
      isTitleVerticalCenter
      className={'add-segment-popup'}
    >
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          // setBtnLoading('send');
          handleSend(values);
        }}
        innerRef={formRef}
      >
        {(props) => {
          const { values, errors, touched, handleSubmit, setFieldValue } =
            props;
          const { preferences } = values;

          return (
            <Row>
              <Col md={6}>
                <div className="p-3 border rounded  ">
                  <div className="">
                    <RegistrationFollowUpsTemplatesForm
                      props={props}
                      paperData={paperData}
                    />
                  </div>
                  <div className="justify-content-start">
                    <div className="text-14-300-18 cmb-5">Send Via :</div>
                    <div className="d-flex gap-3">
                      <div className="d-flex align-items-center gap-2">
                        <CheckBox
                          type="ACTIVE"
                          isChecked={preferences?.whatsapp}
                          onClick={() => {
                            if (preferences?.whatsapp) {
                              setFieldValue('preferences.whatsapp', '');
                            } else {
                              setFieldValue('preferences.whatsapp', 'Whatsapp');
                            }
                          }}
                        />
                        <span className="text-black-olive text-14-300-18">
                          Whats App
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        <CheckBox
                          type="ACTIVE"
                          isChecked={preferences?.email}
                          onClick={() => {
                            if (preferences?.email) {
                              setFieldValue('preferences.email', '');
                            } else {
                              setFieldValue('preferences.email', 'Email');
                            }
                          }}
                        />
                        <span className="text-black-olive text-14-300-18">
                          E-Mail
                        </span>
                      </div>
                    </div>

                    {touched.preferences && errors.preferences && (
                      <span
                        className="text-13-400 pt-1 d-flex"
                        style={{ color: 'red' }}
                      >
                        {errors.preferences}
                      </span>
                    )}
                  </div>

                  <div className="d-flex align-items-center gap-2 cmt-10">
                    <Button
                      text="Send"
                      btnStyle="primary-dark"
                      className="h-35 cps-20 cpe-20"
                      onClick={handleSubmit}
                      btnLoading={btnLoading === 'send'}
                    />
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <div className="border rounded">
                  <div className="bg-FBF6">
                    <div
                      className="h-538 iferp-scroll overflow-auto cp-20"
                      ref={templatePreview}
                    >
                      {getRegistrationTemplatesPreview(values)}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default PreviewPopup;
